import { handleActions } from 'redux-actions';
import { State } from './model';

const Reducer = handleActions({
  // common
}, State);

export default Reducer;